<template>
  <div class="input-group align-items-stretch">
    <div
      v-if="prepend"
      class="input-group-prepend align-self-stretch">
      <span class="input-group-text">{{ prepend }}</span>
      <slot name="apendLabel" />
    </div>
    <slot />
    <div
      v-if="required"
      class="input-group-append">
      <span
        id="inputGroupAppend"
        class="input-group-text">
        <i class="fas fa-star-of-life"/>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormLabel',
  components: {},
  props: {
    prepend: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.input-group {
  align-items: center;
  height: 2.5rem;
}
.form-control {
  display: flex;
  height: auto;
}
i {
  font-size: 10px;
}
</style>
